import { useOidcUser } from '@axa-fr/react-oidc';

export const extractRoles = (oidcUser: any): string[] => {
  if (!oidcUser) return [];
  const profile = oidcUser.profile ?? oidcUser ?? {};
  let roles: string[] = [];

  if (Array.isArray(profile.roles)) roles = profile.roles;
  if (!roles.length && Array.isArray(profile.role)) roles = profile.role;
  if (!roles.length && typeof profile.role === 'string') roles = [profile.role];

  if (!roles.length && profile.realm_access?.roles) {
    roles = roles.concat(profile.realm_access.roles);
  }
  if (!roles.length && profile.resource_access && typeof profile.resource_access === 'object') {
    Object.values(profile.resource_access).forEach((val: any) => {
      if (val?.roles && Array.isArray(val.roles)) roles = roles.concat(val.roles);
    });
  }

  Object.keys(profile).forEach((k) => {
    const lower = k.toLowerCase();
    if (lower.includes('role') || lower.includes('roles') || lower.includes('group')) {
      const v = profile[k];
      if (Array.isArray(v)) roles = roles.concat(v);
      else if (typeof v === 'string') roles.push(v);
    }
  });

  return Array.from(new Set(roles.map((r) => String(r).toLowerCase())));
};

const useRoles = (): string[] => {
  const { oidcUser } = useOidcUser();
  return extractRoles(oidcUser);
};

export default useRoles;
